<template>
  <div class="dialog-new">
    <el-dialog :title="name"
               :visible="visible"
               :append-to-body="isAppendBody"
               @close="cancleOperate('close')"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <span slot="title" v-if="name=='导出问答' || name=='导入问答'" style="font-size: 18px;color: #303133;line-height: 24px;">
        {{name}}
        <el-tooltip class="item" effect="dark" :content="$t('m.common.show_video')" placement="right">
          <a v-if="name=='导出问答'"
             @click.stop
             href="http://bot.4paradigm.com/doc/video/%E5%AF%BC%E5%87%BA%E5%8A%9F%E8%83%BD.mp4"
             target="_blank">
            <i class="el-icon-question"></i>
          </a>
          <a v-if="name=='导入问答'"
             @click.stop
             href="http://bot.4paradigm.com/doc/video/%E5%AF%BC%E5%85%A5%E5%8A%9F%E8%83%BD.mp4"
             target="_blank">
            <i class="el-icon-question"></i>
          </a>
        </el-tooltip>
      </span>
      <div class="body">
        <slot></slot>
      </div>
      <span slot="footer" class="dialog-footer" v-if="showButton">
        <el-button @click="cancleOperate()">{{buttonName[0]}}</el-button>
        <el-button type="primary" @click="sureOperate()" :disabled="sureDisabled">{{buttonName[1]}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
    export default {
      name: "dialog-new",
      props:{
        visible:Boolean,
        name:String,
        sureDisabled:{
          type:Boolean, //确认按钮是否有禁用状态
          default:false
        },
        showButton:{
          type:Boolean, //是否展示确认取消按钮
          default: true
        },
        isAppendBody:{
          type:Boolean, //是否append到body， 给二级弹框使用
          default:false
        },
        buttonName:{
          type:Array, //按钮名称
          default: function () {
            return [this.$t(`m.common.cancle`),this.$t(`m.common.sure`)]
          }
        },
        closeEqualCancle:{
          type:Boolean, //关闭与取消同操作，  （兼容新手教程）
          default:true,
        }
      },
      methods:{
        sureOperate() {
          this.$emit('sure')
        },
        // 关闭与取消同操作
        cancleOperate(type='cancle') {
          if (!this.closeEqualCancle && type == 'close') {
            this.$emit('close')
            return;
          }
          this.$emit('cancel');
        },
      }
    }
</script>

<style scoped lang="less">

</style>
<style lang="less">
  .el-dialog {
    position: absolute !important;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%,-50%);
    border-radius: 4px;
    /*font-size: 18px;*/
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    padding-bottom: 10px;
    border: 1px solid #ebeef5;
    width: auto !important;
    .body {
      max-height: 70vh;
      overflow: auto;
    }
    .el-dialog__header {
      padding: 15px 15px 10px;
      span {
        .el-tooltip {
          cursor: pointer;
          color: #3ba1ff;
        }
      }
    }
    .el-dialog__footer {
      padding: 5px 15px 0;
    }
    .el-dialog__body {
      padding: 10px 15px;
      font-size: 14px;
      color: #606266;
    }
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-form {
      width: 510px;
    }
    .el-input-number {
      .el-input {
        width: auto;
      }
    }
    .el-select {
      .el-input {
        width: auto !important;
      }
    }
    .el-radio__label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-input-number {
      line-height: 28px;
      border-radius: 0;
    }
    .el-input-number .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-form-item {
      .number {
        position: absolute;
        z-index: 1;
        right: 5px;
        color: #d8dde9;
        font-size: 12px;
      }
    }
    // .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    //   display: none;
    // }
    .uploadType {
      .el-tabs__content {
        margin-top: 1px;
        border-top: none !important;
      }
      .el-tabs__header {
        border-bottom: 1px solid #E4E7ED !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogNew.vue